import { useQuery } from '@tanstack/react-query';
import { Icon } from '../components/Icon.tsx';
import { usersApi } from '../features/users/api.ts';
import { dv } from '../i18n/dv.ts';
import { displayName, roleLabel } from '../lib/utils.ts';

const OFFICE_URL = 'https://office.wapplify.app';

export function OrgUsers(): JSX.Element {
  const { data: users, isLoading } = useQuery({ queryKey: ['orgUsers'], queryFn: usersApi.list });

  return (
    <div className="space-y-6">
      {/* User management has moved to Wapplify Office. This list is read-only. */}
      <section className="card-paper flex flex-wrap items-center justify-between gap-3 p-4">
        <div>
          <p className="font-medium">{dv.users.managedInOffice}</p>
          <p className="text-sm text-muted-foreground">{dv.users.managedInOfficeHint}</p>
        </div>
        <a
          href={OFFICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
        >
          {dv.users.openOffice}
          <Icon name="open_in_new" size={18} />
        </a>
      </section>

      <section className="card-paper divide-y divide-border">
        {(users ?? []).map((u) => (
          <div
            key={u.id}
            className={`flex flex-wrap items-center justify-between gap-3 p-4 ${!u.isActive ? 'opacity-60' : ''}`}
          >
            <div>
              <p className="font-medium">
                {displayName(u)}
                {u.isOrgAdmin && (
                  <span className="pill pill-success ms-2">
                    {dv.orgAdminBadge}
                  </span>
                )}
                {!u.isActive && (
                  <span className="pill pill-pending ms-2">
                    {dv.common.inactive}
                  </span>
                )}
              </p>
              <p className="text-sm text-muted-foreground">
                {u.designationEn ?? roleLabel(u.role, u.zoneRole, dv.roles)}
              </p>
              <p className="text-sm text-muted-foreground" dir="ltr">{u.email}</p>
            </div>
          </div>
        ))}
        {(users ?? []).length === 0 && (
          <p className="p-4 text-center text-sm text-muted-foreground">{isLoading ? dv.common.loading : dv.users.empty}</p>
        )}
      </section>
    </div>
  );
}
